export const RESET_HEADER_OBJ = "RESET_HEADER_OBJ";
export const HEADER_ERROR = "HEADER_ERROR";

export const GET_CSAT = "GET_CSAT";
export const SET_CSAT = "SET_CSAT";
export const GET_NPS = "GET_NPS";
export const SET_NPS = "SET_NPS";
export const SET_HEADER_INDICATORS = "SET_HEADER_INDICATORS";
